import script from "./RankTableKS.vue?vue&type=script&setup=true&lang=js"
export * from "./RankTableKS.vue?vue&type=script&setup=true&lang=js"

import "./RankTableKS.vue?vue&type=style&index=0&id=61d7dd86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d7dd86"]])

export default __exports__